module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "cooking.a613aee4.png";